import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rawmaterialspayments',
  templateUrl: './rawmaterialspayments.component.html',
  styleUrls: ['./rawmaterialspayments.component.css']
})
export class RawmaterialspaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
